// @flow
const CANONICAL_MAIN_DOMAIN: string = require('const/settings.json').CANONICAL_MAIN_DOMAIN;

const CUSTOM_DEEPLINK_SCHEME = 'pinterest://';

// $FlowFixMe Flow v0.104.0 upgrade supression.
export type Deeplinks = (params: *, query: *) => { androidDeeplink?: string, iOSDeeplink?: string };

export const buildCrossPlatformDeeplinksFromPath = (path: string) => {
  const iOSDeeplink = CUSTOM_DEEPLINK_SCHEME + path;
  const androidDeeplink = CUSTOM_DEEPLINK_SCHEME + CANONICAL_MAIN_DOMAIN + '/' + path;
  return { androidDeeplink, iOSDeeplink };
};

export const buildBoardDeeplinks = (username: string, slug: string) => {
  const deeplink = CUSTOM_DEEPLINK_SCHEME + 'board/' + username + '/' + slug;

  return { androidDeeplink: deeplink, iOSDeeplink: deeplink };
};

export const buildBoardSectionDeeplinks = (
  username: string,
  boardSlug: string,
  sectionSlug: string,
) => {
  // use buildCrossPlatformDeeplinksFromPath once android deeplink is ready
  const deeplink = `${CUSTOM_DEEPLINK_SCHEME}${username}/${boardSlug}/${sectionSlug}`;
  return { iOSDeeplink: deeplink };
};

export const buildCategoryDeeplinks = (categoryId: string) =>
  buildCrossPlatformDeeplinksFromPath(`categories/${categoryId}`);

export const buildConversationDeeplinks = (conversationId: string) =>
  buildCrossPlatformDeeplinksFromPath(`conversation/${conversationId}`);

export const buildDidItDeepLinks = (pinId: string, didItId: string) =>
  buildCrossPlatformDeeplinksFromPath(`${pinId}/?featured_did_it_ids=${didItId}`);

export const buildDiscoverTopicsDeeplinks = (topicId: string) => {
  const iOSDeeplink = CUSTOM_DEEPLINK_SCHEME + 'discover_topics/' + topicId;
  const androidDeeplink =
    CUSTOM_DEEPLINK_SCHEME + CANONICAL_MAIN_DOMAIN + '/discover/topics/' + topicId;

  return { androidDeeplink, iOSDeeplink };
};

export const buildDiscoverArticleDeeplinks = (articleId: string) => {
  const iOSDeeplink = CUSTOM_DEEPLINK_SCHEME + 'discover_article/' + articleId + '/?is_deeplink=1';
  const androidDeeplink =
    CUSTOM_DEEPLINK_SCHEME + CANONICAL_MAIN_DOMAIN + '/discover/article/' + articleId;
  return { androidDeeplink, iOSDeeplink };
};

export const buildCreatePinDeeplinks = (
  method: string,
  media: string,
  sourceUrl: string,
  description: string,
) => {
  const iOSDeeplink =
    `${CUSTOM_DEEPLINK_SCHEME}add_pin/?method=${method}` +
    `&image_url=${media}&source_url=${sourceUrl}&description=${description}`;
  const androidDeeplink =
    `${CUSTOM_DEEPLINK_SCHEME}${CANONICAL_MAIN_DOMAIN}/pin/create/${method}/` +
    `?media=${media}&url=${sourceUrl}&description=${description}`;

  return { androidDeeplink, iOSDeeplink };
};

export const buildHomeFeedDeeplinks = () => ({
  androidDeeplink: CUSTOM_DEEPLINK_SCHEME,
  iOSDeeplink: `${CUSTOM_DEEPLINK_SCHEME}feed/home`,
});

export const buildNewsHubDeeplinks = () => {
  const deeplink = `${CUSTOM_DEEPLINK_SCHEME}news_hub`;
  return { androidDeeplink: deeplink, iOSDeeplink: deeplink };
};

export const buildPinDeeplinks = (pinId: string) => {
  const deeplink = CUSTOM_DEEPLINK_SCHEME + 'pin/' + pinId;
  return { androidDeeplink: deeplink, iOSDeeplink: deeplink };
};

export const buildProfileDeeplinks = (username: string) => {
  const deeplink = CUSTOM_DEEPLINK_SCHEME + 'user/' + username;
  return { androidDeeplink: deeplink, iOSDeeplink: deeplink };
};

export const buildRepinDeeplinks = (pinId: string) => {
  const iOSDeeplink = `${CUSTOM_DEEPLINK_SCHEME}repin/${pinId}`;
  const androidDeeplink = `${CUSTOM_DEEPLINK_SCHEME}pin/${pinId}/repin`;
  return { androidDeeplink, iOSDeeplink };
};

export const buildScopedSearchDeeplinks = (scope: string, query: string) => {
  const iOSDeeplink = `${CUSTOM_DEEPLINK_SCHEME}search/${scope}/?q=${query}`;
  const androidDeeplink = `${CUSTOM_DEEPLINK_SCHEME}search/?q=${query}`;
  return { androidDeeplink, iOSDeeplink };
};

export const buildExploreDeeplinks = (interestName: string) =>
  buildCrossPlatformDeeplinksFromPath(`explore/${interestName}`);

export const buildTopicDeeplinks = (interestName: string) =>
  buildCrossPlatformDeeplinksFromPath(`topics/${interestName}`);

export const buildSearchDeeplinks = (query: string) =>
  buildCrossPlatformDeeplinksFromPath(`search/?q=${query}`);

export const buildUserDeeplinks = (username: string) =>
  buildCrossPlatformDeeplinksFromPath(`user/${username}`);
